module.exports = __webpack_public_path__ + "img/bjbottom2.3f17a048.jpg";